import React from "react";
import { Card, Icon, Button } from "antd";

export const MatspecComponent = props => {
  return (
    <div
      className="mobile--card"
      id={props.id}
      data-highlighted={props.highlighted}
    >
      <Card
        size="small"
        title={"Matspec " + props.name}
        extra={
          <Button size="small" type="primary" onClick={props.onClick}>
            <Icon type="caret-right" />
          </Button>
        }
      >
        {props.children}
      </Card>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/Mobile/Matspec/MatspecComponent.js